<template>
    <div>
    <div  :class="{ 'slide-up-menu-dismisser':true, 'slide-up': menuProp.active }" @click="$emit('toggle:menu')"></div>
    <ul class="slide-up-menu" :class="{ 'slide-up': menuProp.active }">
        <li>{{getTitle(menuProp.index)}}<img src="@/assets/cross.svg" alt="img" class="responsive-img" @click="$emit('toggle:menu')"/></li>
        <li>
            <template v-if="menuProp.index === 'viewRequest'">
            <a @click="$emit('callback', 'requestDetails')" name="requestDetails">
                {{$t("slideUpMenu.viewRequest.details")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'requestContacts')" name="requestContacts">
                {{$t("slideUpMenu.viewRequest.contacts")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'requestAttachments')" name="requestAttachments">
                {{$t("slideUpMenu.viewRequest.requestAttachments")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
             <a @click="$emit('callback', 'requestViolations')" name="requestViolations">
                {{$t("slideUpMenu.viewRequest.requestViolations")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a v-show="canGotoActivity()" @click="$emit('callback', 'requestActivity')" name="requestActivity">
                {{$t("slideUpMenu.viewRequest.requestAuditLog")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            </template>

				<template v-if="menuProp.index === 'actionRequestedChanges'">
					<a v-show="hasChangesRequested()" @click="$emit('callback', 'actionRequestedChangesDiscard')" name="actionRequestedChangesDiscard">
						{{$t("slideUpMenu.actionRequestedChanges.discard")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
					</a>
					<a v-show="hasChangesRequested()" @click="$emit('callback', 'actionRequestedChangesEdit')" name="actionRequestedChangesEdit">
						{{$t("slideUpMenu.actionRequestedChanges.editChanges")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
					</a>
					<a v-show="!hasChangesRequested()" @click="$emit('callback', 'actionRequestedChangesEdit')" name="actionRequestedChangesEdit">
						{{$t("slideUpMenu.actionRequestedChanges.newChanges")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
					</a>
				</template>


            <template v-if="menuProp.index === 'actionRequest'">
            <a @click="$emit('callback', 'actionRequestEdit')" name="actionRequestEdit">
                {{$t("slideUpMenu.actionRequest.edit")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a v-show="canCancelRequest()" @click="$emit('callback', 'actionRequestCancel')" name="actionRequestCancel">
                {{$t("slideUpMenu.actionRequest.cancel")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a v-if="false" v-show="canReportContravention()" @click="$emit('callback', 'actionRequestReportViolation')" name="actionRequestReportViolation">
                {{$t("slideUpMenu.actionRequest.reportViolation")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
					<a v-show="canDuplicateRequest()" @click="openWarningModal" name="actionRequestDuplicate">
                {{$t("slideUpMenu.actionRequest.duplicate")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
	        <a v-show="canCompleteRequest()" class="slide-up-menu--highlight" @click="$emit('callback', 'actionRequestComplete')" name="actionRequestComplete">
	            {{$t("slideUpMenu.actionRequest.complete")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
	        </a>

					<a v-show="hasRequestedChanges()" class="slide-up-menu--requested-changes" @click="$emit('callback', 'actionViewRequestedChanges')" name="actionViewRequestedChanges">
						{{$t("slideUpMenu.actionRequest.viewRequestedChanges")}}<img src="@/assets/downarrow-requested-changes.svg" alt="img" class="responsive-img"/>
					</a>
            </template>


				<template v-if="menuProp.index === 'viewRequestedChanges'">
					<a @click="$emit('callback', 'requestDetails')" name="requestDetails">
						{{$t("slideUpMenu.viewRequestedChanges.backToDetails")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
					</a>
				</template>








				<template v-if="menuProp.index !== 'viewRequest' && menuProp.index !== 'viewRequestedChanges' && menuProp.index !== 'actionRequest' && menuProp.index !== 'actionRequestedChanges' && menuProp.index !== 'contraventions' && menuProp.index !== 'report'">
            <a class="slide-up-menu--has-badge" v-for="(count, name) in menuProp.lists" :key="'name'+name" @click="$emit('callback', name)">
                <span class="slide-up-menu--badge"><b-badge>{{ count }}</b-badge></span>{{ getListTitle(menuProp.index,name) }}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'all')" name="all">
                {{getAllText(menuProp.index)}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a v-show="canReportContravention()"  class="slide-up-menu--highlight" v-if="menuProp.index == 'contraventions'" @click="$emit('callback', 'newContravention')" name="newContravention">
                {{$t("slideUpMenu.contraventions.newRequestWithViolation")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'newEmergency')"  class="slide-up-menu--highlight" v-if="menuProp.index == 'restrictions' || menuProp.index == 'closures'" name="newEmergency">
                {{getEmergencyText(menuProp.index)}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'newRequest')" class="slide-up-menu--highlight" name="newRequest" v-if="menuProp.index == 'requests'">
                {{getNewRequestText(menuProp.index)}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            </template>


            <template v-if="menuProp.index == 'contraventions' && canReportContravention()">
            <a class="slide-up-menu--has-badge" v-for="(count, name) in menuProp.lists" :key="'name'+name" @click="$emit('callback', name)">
                <span class="slide-up-menu--badge"><b-badge>{{ count }}</b-badge></span>{{ getListTitle(menuProp.index,name) }}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'all')" name="all">
                {{getAllText(menuProp.index)}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'newEmergency')"  class="slide-up-menu--highlight" v-if="menuProp.index == 'restrictions' || menuProp.index == 'closures'" name="newEmergency">
                {{getEmergencyText(menuProp.index)}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'newRequest')"  class="slide-up-menu--highlight" name="newRequest" v-if="menuProp.index == 'requests'">
                {{getNewRequestText(menuProp.index)}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            <a @click="$emit('callback', 'newContravention')" class="slide-up-menu--highlight" name="newContravention">
                {{$t("slideUpMenu.contraventions.newRequestWithViolation")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            </a>
            </template>


            <template v-if="menuProp.index === 'report'">
            	<a @click="$emit('callback', 'reportClosure')" name="reportClosure">
            	    {{$t("slideUpMenu.report.reportClosure")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            	</a>
            	<a @click="$emit('callback', 'reportRestriction')" name="reportRestriction">
            	    {{$t("slideUpMenu.report.reportRestriction")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            	</a>
            	<a v-show="canReportContravention()" @click="$emit('callback', 'reportViolation')" name="reportViolation">
            	    {{$t("slideUpMenu.report.reportViolation")}}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
            	</a>
            </template>

            <!-- <template v-if="menuProp.index == 'contraventions' && !canReportContravention()">
                <a v-if="name == 'with'" v-for="(count, name) in menuProp.lists" :key="'name'+name" @click="$emit('callback', name)">
                    <span class="slide-up-menu--badge"><b-badge>{{ count }}</b-badge></span>{{ getListTitle(menuProp.index,name) }}<img src="@/assets/downarrow.svg" alt="img" class="responsive-img"/>
                </a>
            </template> -->


        </li>
    </ul>
	<warning-modal ref="warningModal" @action-confirmed="$emit('callback', 'actionRequestDuplicate')">
		<p>You are duplicating ALL information from this previous request into a new request.</p>
		<p>Please review the duplicated information on each tab to ensure it is correct and applicable to the NEW request.</p>
	</warning-modal>
    </div>
</template>

<script>
import WarningModal from './WarningModal.vue';

export default {
    name: 'SlideUpMenu',
    props: {
        menuProp: Object
    },
	components: {
		WarningModal,
	},
    methods: {
        getTitle(index) {
            return this.$t("slideUpMenu."+index+".title");
        },
        getListTitle(index,name) {
            return this.$t("slideUpMenu."+index+"."+name+"");
        },
        getNewRequestText(index) {
            return this.$t("slideUpMenu."+index+".newRequest");
        },
        getAllText(index) {
            return this.$t("slideUpMenu."+index+".all");
        },
        getEmergencyText(index) {
            return this.$t("slideUpMenu."+index+".newEmergency");
        },

        // Security Checks
        canGotoActivity() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin') || this.$store.getters.userHasRole('internal_admin_reports')) {
				return true;
			}
			return false;
		},


		hasChangesRequested() {
			this.laneClosureRequest = this.$store.getters['laneClosureRequest/data'];
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.lcrChangeRequestId) {
					return true;
				}
			}
			return false;
		},


        canReportContravention() {
            return this.$store.getters.userCanReportContravention();
        },
        canCancelRequest() {
            this.laneClosureRequest = this.$store.getters['laneClosureRequest/data'];
            let canReport = false;
            if (this.$store.getters.userInfo() == null) {
            	return false;
            }
            if (this.laneClosureRequest) {
            	if (this.laneClosureRequest.recordStatusId.value != 7) {
            		let thisUserId = this.$store.getters.userId();
            		let thisOrgId = this.$store.getters.userInfo().organizationId;
            		let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
            		let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
            		let canAll = this.$store.getters.userHasPermission('lcr_update_all');

            		if (!canMine && !canAll && !canOrg) {
            			return false;
					}

            		if (canAll) {
            			canReport = true;
				}

            		if (!canReport) {
            			if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
            				canReport = true;
            }
            		}

            		let x = 0;
            		let orgs = [];
            		if (!canReport) {
            			if (canOrg) {
            				orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
            				if (orgs.includes(""+thisOrgId)) {
            					canReport = true;
            				}
            			}
            		}
            		if (!canReport) {
            			if (this.laneClosureRequest.altRequester) {
            				for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
            					if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
            						canReport = true; // they can always report if they are an alternate requester...
            					}
            					if (canReport == false) {
            						if (canOrg) {
            							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
            							if (orgs.includes(""+thisOrgId)) {
            								canReport = true;
            							}
            						}
            					}
            				}
            			}
            		}
            	}
            }
            return canReport;


        },

		openWarningModal() {
			this.$refs.warningModal.openModal();
		},
        canDuplicateRequest() {
            if (this.$store.getters.userInfo() == null) {
            	return false;
            }
            this.laneClosureRequest = this.$store.getters['laneClosureRequest/data'];

            // if (this.laneClosureRequest) {
            // 	if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
            // 		return true;
            // 	}
            // 	if (this.$store.getters.userId() == this.laneClosureRequest.requesterId) {
            // 		return true;
            // 	}
            // 	if (this.$store.getters.userInfo() && this.$store.getters.userInfo().userOrganizations.includes(this.laneClosureRequest.requester.organizationId)) {
            // 		return true;
            // 	}
            // }

            let canReport = false;
            if (this.laneClosureRequest) {
				// if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
            		let thisUserId = this.$store.getters.userId();
            		let thisOrgId = this.$store.getters.userInfo().organizationId;
            		let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
            		let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
            		let canAll = this.$store.getters.userHasPermission('lcr_update_all');

            		if (!canMine && !canAll && !canOrg) {
            			return false;
				}

            		if (canAll) {
            			canReport = true;
				}

            		if (!canReport) {
            			if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
            				canReport = true;
				}
			}

            		let x = 0;
            		let orgs = [];


            		if (!canReport) {
            			if (canOrg) {
            				orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
            				if (orgs.includes(""+thisOrgId)) {
            					canReport = true;
            				}
            			}
            		}
            		if (!canReport) {
            			if (this.laneClosureRequest.altRequester) {
            				for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
            					if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
            						canReport = true; // they can always report if they are an alternate requester...
            					}
            					if (canReport == false) {
            						if (canOrg) {
            							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
            							if (orgs.includes(""+thisOrgId)) {
            								canReport = true;
            							}
            						}
            					}
            				}
            			}
            		}
				// }
            }
            return canReport;
        },

		hasRequestedChanges() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.lcrChangeRequestId) {
					return true;
				}
			}
			return false;
		},



        canCompleteRequest() {
            if (this.$store.getters.userInfo() == null) {
            	return false;
            }
            this.laneClosureRequest = this.$store.getters['laneClosureRequest/data'];

            let canReport = false;
            if (this.laneClosureRequest) {
            	if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
            		let thisUserId = this.$store.getters.userId();
            		let thisOrgId = this.$store.getters.userInfo().organizationId;
            		let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
            		let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
            		let canAll = this.$store.getters.userHasPermission('lcr_update_all');

            		if (!canMine && !canAll && !canOrg) {
            			return false;
						}

            		if (canAll) {
            			canReport = true;
						}

            		if (!canReport) {
            			if (this.laneClosureRequest.closureReporterId == thisUserId && (canOrg || canMine)) {
            				canReport = true;
					}
            			if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
            				canReport = true;
				}
			}

            		let x = 0;
            		let orgs = [];


            		if (!canReport) {
            			if (canOrg) {
            				orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
            				if (orgs.includes(""+thisOrgId)) {
            					canReport = true;
            				}
            			}
            		}
            		if (!canReport) {
            			if (this.laneClosureRequest.altRequester) {
            				for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
            					if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
            						canReport = true; // they can always report if they are an alternate requester...
            					}
            					if (canReport == false) {
            						if (canOrg) {
            							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
            							if (orgs.includes(""+thisOrgId)) {
            								canReport = true;
            							}
            						}
            					}
            				}
            			}
            		}

            		if (!canReport) {
            			if (this.laneClosureRequest.altClosureReporter) {
            				for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
            					if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
            						canReport = true;
            					}
            					if (canReport == false) {
            						if (canOrg) {
            							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
            							if (orgs.includes(""+thisOrgId)) {
            								canReport = true;
            							}
            						}
            					}
            				}

            			}
            		}

            	}
            }
            return canReport;
        },

        getOrganizationIdTreeList(user) {
        	if (user.organizationIdTree) {
        		let treeString = user.organizationIdTree;
        		let treeList = treeString.split("|");
        		treeList.pop();
        		treeList.shift();
        		treeList.reverse();
        		return treeList;
        	} else {
        		return new Array(user.organizationId);
        	}
        },


    }
}
</script>
